import { Link } from "react-router-dom";
import FavoriteButton from "@/components/FavoriteButton";
import ProviderStatusBadges from "@/components/ProviderStatusBadges";
import LazyImage from "@/components/ui/LazyImage";

interface ServiceCardHeaderProps {
  id: string;
  name: string;
  image: string;
  isFeatured: boolean;
  isTopRated: boolean;
  whatsappVerified: boolean;
  onProviderClick?: () => void;
}

const ServiceCardHeader = ({
  id,
  name,
  image,
  isFeatured,
  isTopRated,
  whatsappVerified,
  onProviderClick,
}: ServiceCardHeaderProps) => {
  return (
    <div className="relative">
      {/* Image */}
      <div className="relative overflow-hidden aspect-[3/2]">
        <ProviderStatusBadges
          isFeatured={isFeatured}
          isTopRated={isTopRated}
          isVerified={whatsappVerified}
          className="absolute left-2 top-2 z-10"
        />
        <div className="absolute top-2 right-2 z-10">
          <FavoriteButton providerId={id} size="sm" />
        </div>
        <Link to={`/service/${id}`} onClick={onProviderClick}>
          <LazyImage src={image} alt={name} className="object-cover" wrapperClassName="w-full h-full" showSkeleton aspect="3/2" />
        </Link>
      </div>
    </div>
  );
};

export default ServiceCardHeader;
